<template>
  <div class="newPerfect">
    <CommonComponent
      :referrerPre="referrer"
      :support="support"
      :elementData="elementData"
    ></CommonComponent>
    <AuthenPopup
      title="提示"
      :isClose="false"
      @define="define"
      btnText="去认证"
      v-model="isShow"
    ></AuthenPopup>
    <Notification
      :isShow="isShowNotif"
      :title="title"
    ></Notification>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CommonComponent from './components/CommonComponent.vue';
import AuthenPopup from './components/AuthenPopup.vue';
import Notification from './components/Notification.vue';

export default {
  name: 'Perfect',
  components: {
    AuthenPopup,
    Notification,
    CommonComponent,
  },
  data() {
    return {
      elementData: [],
      isShow: false,
      isShowNotif: false,
      productId: '',
      referrer: '',
      support: '',
      title: '',
    };
  },
  created() {
    this.getInvitedCodeFromProductId();
  },
  mounted() {
    this.productId = this.$route.query.productId;
    this.getUserInfo();
  },
  watch: {
    'publicPage.personAuthStatus': {
      handler(val) {
        if (val === true) {
          this.isShow = false;
          this.getUnfinishedOrder();
        } else if (val === false) {
          this.isShow = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),

    // 获取orderID

    getInvitedCodeFromProductId() {
      this.$api.CommonForms.getInvitedCodeFromProductId({
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res && res.data) {
          this.referrer = res.data.inviteCode || '';
          this.support = !res.data.support;
          this.getProductionConfig();
        }
      });
    },

    getUnfinishedOrder() {
      this.$api.PublicPage.getUnfinishedOrder({
        productId: this.$route.query.productId,
      })
        .then((res) => {
          if (res.success) {
            if (res.data.show) {
              this.isShowNotif = true;
              this.title = '当前您有未完成的申请';
            } else {
              this.getorderID();
            }
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    // 获取配置项进件
    getProductionConfig() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        productId: this.$route.query.productId,
      }).then((res) => {
        if (res.success) {
          const result = JSON.parse(res.data[0].productConfigs);
          localStorage.setItem('configData', res.data[0].productConfigs);
          this.elementData = [...result];
          console.log(this.elementData, '==elementData');
        }
        this.$toast.clear();
      });
    },

    define(obj) {
      localStorage.setItem(
        'returnPage',
        `/supermarket/v2/Perfect?productId=${this.productId}`,
      );
      this.$router.push('/supermarket/v2/realName');
      obj.cb();
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 32px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
</style>
